'use strict';

var STORE_KEY = 'EventsStore';

function offlineReactNative(AsyncStorage, isConnected) {
  var saveEvents = function saveEvents(events) {
    return AsyncStorage.getItem(STORE_KEY).then(JSON.parse).then(function (oldEvents) {
      if (oldEvents) {
        return oldEvents.concat(events);
      }
      return events;
    }).then(JSON.stringify).then(AsyncStorage.setItem.bind(null, STORE_KEY)).then(function () {
      return events;
    });
  };

  var purgeEvents = function purgeEvents() {
    return AsyncStorage.getItem(STORE_KEY, function () {
      return AsyncStorage.removeItem(STORE_KEY);
    }).then(JSON.parse);
  };
  return {
    isConnected: isConnected,
    saveEvents: saveEvents,
    purgeEvents: purgeEvents
  };
}

module.exports = offlineReactNative;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/extensions/offline-react-native.js
// module id = 335
// module chunks = 0